module.exports = __webpack_public_path__ + "pro-tip-967fdb7ac67871fc9a2874140e5a3b36.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/pro-tip.png
// module id = HWGv
// module chunks = client